<template>
  <button 
    @click="toggleChat"
    class="btn btn-danger rounded-circle d-flex align-items-center justify-content-center shadow position-fixed"
    style="
      width: 56px;
      height: 56px;
      bottom: 24px;
      right: 24px;
      z-index: 1060;
    "
  >
    <svg 
      v-if="!isOpen"
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      stroke-width="2" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    >
      <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"></path>
    </svg>
   <!-- Close X Icon -->
    <svg
      v-else
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>
  <div  
     v-if="isOpen"
    class="card chat-window shadow-lg border-0">
    <ChatContainer  
      @toggleChat="toggleChat" />
    </div>
  
</template>
<script setup>
import {ref } from 'vue'
import ChatContainer from './components/ChatContainer.vue'


const isOpen = ref(false)

const toggleChat = () => {
  isOpen.value = !isOpen.value
}

</script>

<style scoped>
.chat-btn {
  transition: all 0.2s ease;
}

.chat-btn:hover {
  background-color: #c82333 !important;
}

.chat-btn:active {
  transform: scale(0.9);
}
/* Positioning the window */
.chat-window {
    position: fixed;
    bottom: 100px;
    right: 24px;
    width: 380px;
    height: 550px;
    border-radius: 1rem !important;
    z-index: 1050;
}

/* Floating Red Button */
.btn-floating {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 56px;
    height: 56px;
    z-index: 1050;
    font-size: 20px;
}

/* Custom Message Bubble Styling */
.message-bubble {
    max-width: 85%;
    font-size: 0.85rem;
    border-radius: 1rem;
    border-top-left-radius: 0;
    border: 1px solid #f0f0f0;
    padding: 0.75rem;
}

/* Bot Icon sizing */
.bot-icon {
    width: 32px;
    height: 32px;
}

/* Pulse animation for the online dot */
.dot {
    height: 6px;
    width: 6px;
    background-color: #28a745;
    border-radius: 50%;
    display: inline-block;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
}

.user {
  text-align: right;
  margin-left: auto;
  border-top-right-radius: 0;
  border-top-left-radius: 1rem !important;
  background: #1F7FBA  !important;
  color: #fff !important;
}

.bot {
  background: #fff;
}
/* Zoom effect on image hover */
.product-card:hover .hover-zoom {
    transform: scale(1.1);
    transition: transform 0.3s ease;
}

.hover-zoom {
    transition: transform 0.3s ease;
}

/* Custom shadow for the blue button to match Tailwind's shadow-blue-500/20 */
.shadow-blue {
    box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.2), 0 2px 4px -1px rgba(59, 130, 246, 0.1);
}

/* Smooth entry animation like Tailwind's animate-in */
.product-card {
    animation: slideInUp 0.3s ease-out;
}

@keyframes slideInUp {
    from { transform: translateY(8px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}
</style>